import React, { Component, Fragment } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Card } from 'react-toolbox/lib/card'
import { Button } from 'react-toolbox/lib/button'
import { Flex, Box } from 'reflexbox'
import CardHeader from 'components/custom/Card/CardHeader'

import injectSagas from 'helpers/injectSagas'
import MyProjectsSagas from './sagas'

// import Table from 'containers/Project/ElasticSearch/Table'
import Forms from './Forms'

import styles from './styles.scss'

import notifyHoc from 'containers/App/Notification/Notify'

import {
  myProjectsListSelector,
  selectedProjectsStateSelector,
  changedProjectsStateSelector,
  currentFormChangesStateSelector,
  rowSizeSelector,
  inputValueSelector,
  rowSizeStateSelector,
  filtersAndQuerySelector,
  popupActiveSelector,
  popupPageSelector,
  loadingActiveSelector,
  errorsSelector,
  customViewsSelector,
  selectedViewSelector,
  changedListSelector,
  searchFiltersStateSelector,
  headersSelector
} from './selectors'

import {
  updateSelectedProjectsAction,
  cancelChangesPopup,
  submitChanges,
  onRowSizeChange,
  onInputChange, 
  onSubmit,
  removeHeaderFilter,
  onTogglePopup,
  clearChanges,
  onSelectCustomView,
  resetProductFilters,
  filterChange
} from './actions'

import RefreshProductListButton from './RefreshListButton'

import { onEnter } from 'helpers/events'

import Table from 'containers/MyProjects/Table'
import Input from './Table/Input'
import Dropdown from './Table/Dropdown'
import Chip from './Table/Chip'

import Popup from './Popup/index'
import NestedDropdown from './NestedDropdown/Dropdown'
import FilterDropdown from './FilterDropdown/Dropdown'

import { defaultSearchFilterNames, defaultSearchFilterSource } from './constants'

const NotifyChip = notifyHoc(Chip)

const mapStateToProps = (state) => {
  return {
    list: myProjectsListSelector(state),
    inputValue: inputValueSelector(state),
    selectedProjects: selectedProjectsStateSelector(state),
    changedProjects: changedProjectsStateSelector(state),
    currentChanges: currentFormChangesStateSelector(state),
    rowSizes: rowSizeSelector(state),
    rowSize: rowSizeStateSelector(state),
    filters: filtersAndQuerySelector(state),
    popupActive: popupActiveSelector(state),
    popupPage: popupPageSelector(state),
    loadingActive: loadingActiveSelector(state),
    errors: errorsSelector(state),
    customViews: customViewsSelector(state),
    selectedView: selectedViewSelector(state),
    changedList: changedListSelector(state),
    searchFilters: searchFiltersStateSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onEnterPress: onEnter((event) => dispatch(onSubmit(event))),
    onInputChange: (value) => dispatch(onInputChange(value)),
    onRowSizeChange: (rowSize) => dispatch(onRowSizeChange(rowSize)),
    updateSelectedProjects: (project) => dispatch(updateSelectedProjectsAction(project.id)),
    cancelChangesPopup: () => dispatch(cancelChangesPopup()),
    submitChanges: () => dispatch(submitChanges()),
    onTogglePopup: () => dispatch(onTogglePopup()),
    onToggleCancelPopup: () => dispatch(onToggleCancelPopup()),
    removeHeaderFilter: (filter) => dispatch(removeHeaderFilter(filter)),
    clearChanges: () => dispatch(clearChanges()),
    onSelectCustomView: (view) => dispatch(onSelectCustomView(view)),
    resetProductFilters: () => dispatch(resetProductFilters()),
    filterChange: (value) => dispatch(filterChange(value))
  }
}
class MyProjects extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formIndex: 2,
      searchInput: "",
      rowSize: 100
    }
  }
  onFormChange = (index) => this.setState({ formIndex: index })
  onSearchInputChange = (input) => this.setState({ searchInput: input })
  onRowSizeChange = (value) => this.setState({ rowSize: value }) 

  onSelectDropdown(key) {
    this.props.onSelectCustomView(key)
  }

  render() {
    const { 
      cancelChangesPopup,
      submitChanges,
      onEnterPress,
      rowSizes,
      onInputChange,
      onRowSizeChange,
      inputValue,
      rowSize,
      filters,
      onTogglePopup,
      popupActive,
      popupPage,
      loadingActive,
      changedProjects,
      clearChanges,
      removeHeaderFilter,
      selectedProjects,
      errors,
      customViews,
      selectedView,
      resetProductFilters,
      changedList,
      searchFilters,
      filterChange
    } = this.props
    return (
      <div styleName="myProjectsPage">
      <Fragment>
      <Flex styleName="topCards">
        <Box w={1} p={1}>
            <Card theme={styles}>
                <CardHeader title="My Projects" />
                <Flex styleName="extraComponents">
                  <div>
                    <NestedDropdown
                      source={customViews}
                      onChange={(key) => this.onSelectDropdown(key)}
                      selectedView={selectedView}
                    />
                    <RefreshProductListButton message={'Refresh Header Filters'} onClick={resetProductFilters} />

                  </div>
                  <div>
                    {
                      filters.map((filter, idx ) => (
                        <NotifyChip
                          deletable
                          message='Click to Delete Filter'
                          key={`${idx}_chip`}
                          label={`${defaultSearchFilterNames[Object.keys(filter)[0]]}: ${Object.values(filter)[0]}`}
                          value={Object.keys(filter)[0]}
                          onDeleteClick={() => removeHeaderFilter(filter)}
                          onClick={() => removeHeaderFilter(filter)}
                        />
                      ))
                    }
                  </div>
                  <div>
                      <Button  
                        primary
                        disabled={changedProjects.length < 1}
                        label={"Submit"}
                        onClick={submitChanges}
                      />
                      <Button
                        secondary={"true"}
                        label={"Cancel Changes"}
                        disabled={changedProjects.length < 1}
                        onClick={cancelChangesPopup}
                      />
                    </div>

                </Flex>
                <Flex align='center' ml={1} mr={1}>
                  <FilterDropdown
                    selectedFilters={searchFilters}
                    onClick={filterChange}
                    sourceFilters={defaultSearchFilterSource}
                  />
                  <Box auto>
                    <Input 
                      icon='search'
                      hint='Search Projects...'
                      value={inputValue}
                      onChange={onInputChange}
                      onKeyPress={onEnterPress}
                    />
                  </Box>
                  <Dropdown 
                    value={rowSize}
                    source={rowSizes}
                    onChange={onRowSizeChange}
                    label='Row Size'
                  />
                </Flex>
                <Table />
            </Card>
        </Box>
      </Flex>
      <Box styleName="formFieldsBox" w={1} px={1}>
          <Card styleName="formFieldsCard">
              <CardHeader title="Form Fields">
              </CardHeader>
              <Forms 
                selectedProjects={selectedProjects}
              />
          </Card>
        </Box>
        <Popup
          onTogglePopup={onTogglePopup}
          popupActive={popupActive}
          page={popupPage}
          errors={errors}
          clearChanges={clearChanges}
          loadingActive={loadingActive}
          changedList={changedList}
        />
      </Fragment>
      </div>
    )
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ 'fulcrum/containers/MyProjects' : MyProjectsSagas })

const enhance = compose(
  withConnect,
  withSagas,
  withStyle
)
export default enhance(MyProjects)
